import { useNavigate } from "react-router-dom"
import MTable from "../../../../components/mtable"

export default function Resources() {
    
    const navigate = useNavigate()
    const create = () => navigate('resources/create')

    const resourcesMapper = {columns: [
        {
            label: "Name",
            value: (item) => item.name
        },
        {
            label: "Type",
            value: (item) => item.type
        },
        {
            label: "Status",
            value: (item) => item.status
        },
    ]}

    const details = (resource) => navigate(`resources/${resource.id}`)

    return(<>
        <div className="flex space-between gap-xs v-spacer-m">
            <p className="section-title">Resources</p>
            <button className="solid" onClick={create}>Create Resources</button>
        </div>
        <MTable path={'resources'} mapper={resourcesMapper} onClick={details} />
    </>)
}